import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import SidebarProposal from '../../../layouts/sidebarProposal/SidebarProposal'
import ApprovedExpert from '../../../widgets/approvedExpert/ApprovedExpert'
import SendSelectedExpert from '../../../widgets/sendSelectedExpert/SendSelectedExpert'
import PanalLoadingTemplate from '../../../widgets/loadingTemplate/panalLoadingTemplate/PanalLoadingTemplate'
import ErrorWidget from '../../../widgets/errorWidget/ErrorWidget'
import { startLoading, doneLoading } from '../../../utils/loading'
import { getSchemaSendAssignExpert } from '../../../redux/actions/assignExpert'
import ProjectBasicInfo from '../../../widgets/projectBasicInfo/ProjectBasicInfo'
import ContentHeader from '../../../components/ContentHeader/ContentHeader'

export default function SendAssignExpert() {
  const SELECTED_EXPERT = 'selectedExpert'

  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState()
  const [schema, setSchema] = useState()
  const [selectedExpert, setSelectedExpert] = useState()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')

  useEffect(() => {
    handleGetSchema()
  }, [])

  const handleGetSchema = async () => {
    setIsLoading(true)
    startLoading()
    try {
      const _schema = await getSchemaSendAssignExpert(projectId)
      setSchema(_schema.model)
    } catch (e) {
      setError({})
    }
    doneLoading()
    setIsLoading(false)
  }

  useEffect(() => {
    let _selectedExpert = []
    try {
      _selectedExpert = JSON.parse(sessionStorage.getItem(SELECTED_EXPERT)) || []
      setSelectedExpert(_selectedExpert)
    } catch (e) {}
  }, [])

  if (error) {
    return (
      <SidebarProposal>
        <ErrorWidget statusCode={error.statusCode} errorMessage={error.errorMessage} />
      </SidebarProposal>
    )
  }

  if (!schema || isLoading) {
    return (
      <SidebarProposal>
        <PanalLoadingTemplate />
      </SidebarProposal>
    )
  }

  return (
    <SidebarProposal>
      <ContentHeader header={schema.header} subHeader={schema.subHeader} />

      <ProjectBasicInfo schema={schema.forms?.ProjectInfo} />
      <br />
      {schema.forms?.ReviewerApproveList?.itemsList?.length > 0 && (
        <>
          <ApprovedExpert schema={schema.forms?.ReviewerApproveList} />
          <br />
        </>
      )}

      <SendSelectedExpert
        schema={schema.forms?.ReviewerAddedList}
        schemaButton={schema?.forms}
        onSuccess={() => handleGetSchema(projectId)}
        //selectedExpert={selectedExpert?.filter(i=> !i.sendConsiderDate)}
        selectedExpert={selectedExpert}
        onUpdateSchema={() => {
          setSelectedExpert([])
          handleGetSchema()
        }}
        reviewerApproveList={schema.forms?.ReviewerApproveList.itemsList}
      />
      <br />
    </SidebarProposal>
  )
}
